import { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Link } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { getMethod, postMethod } from "../../../../function/helper";
import validateFormatNationalCode from "../../../../function/validateFormatNationalCode";
import BirthDay from "./Form/BirthDay";
import "./NormalUserRegister.css";
import RegisterUserSendAuthCode from "./RegisterUserSendAuthCode";

function NormalUserRegister() {
  const [type, setType] = useState("حقیقی");
  const [form, setForm] = useState({
    type: type,
    area: 0,
    province: 0,
    city: 0,
    name: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [infoLoading, setInfoLoading] = useState(false);
  const [showModalCode, setShowModalCode] = useState(false);
  const [phone, setPhone] = useState("");

  const [provinces, setprovinces] = useState([]);
  const [areas, setAreas] = useState([]);

  const [cityOption, setCityOption] = useState([{ value: 0, label: "..." }]);

  const getProvince = async () => {
    setInfoLoading(true);
    const province = await getMethod("/address/v1/province/show/1");
    setInfoLoading(false);

    setprovinces(province.data);
  };

  const getCities = async id => {
    setField("province", id);
    setForm(cur => ({ ...cur, area: 0, city: 0 }));
    setAreas([]);

    setInfoLoading(true);
    const city = await getMethod("/address/v1/city/show/" + id);
    setInfoLoading(false);

    const optionCity = [{ value: 0, label: "..." }];
    for (let i = 0; i < city.data.length; i++) {
      optionCity.push({ value: city.data[i].id, label: city.data[i].faName });
    }
    setCityOption(optionCity);
  };

  const handleChangeCity = async data => {
    setField("city", data.value);
    setForm(cur => ({ ...cur, area: 0 }));
    setErrors(cur => {
      delete cur.area;
      return { ...cur };
    });

    setInfoLoading(true);
    const res = await getMethod(
      `/address/v1/area/getByCityId?cityId=${data.value}`
    );
    setInfoLoading(false);

    if (res && res.status === 200) {
      setAreas(res.result);
    }
  };

  const setField = (field, value) => {
    setForm(cur => ({ ...cur, [field]: value }));
    if (errors[field]) setErrors(cur => ({ ...cur, [field]: null }));
  };

  const findFormErrors = () => {
    const newErrors = {};
    if (type === "حقیقی") {
      const {
        name,
        family,
        phone,
        nationalCode,
        password,
        repassword,
        province,
        city,
        address,
        postCode,
        tel,
        birthDay,
        area,
      } = form;

      if (!name || name === "") newErrors.name = "نام الزامی است";
      if (!family || family === "")
        newErrors.family = "نام خانوادگی الزامی است";
      if (!phone || phone === "") {
        newErrors.phone = "موبایل الزامی است";
      } else if (phone.length !== 11) {
        newErrors.phone = "شماره موبایل باید 11 رقم باشد";
      } else if (phone[0] != 0 || phone[1] != 9) {
        newErrors.phone = "شماره موبایل معتبر نمی باشد";
      }

      let meli_code;
      meli_code = nationalCode;
      if (nationalCode) {
        if (meli_code.length === 10) {
          if (
            meli_code === "1111111111" ||
            meli_code === "0000000000" ||
            meli_code === "2222222222" ||
            meli_code === "3333333333" ||
            meli_code === "4444444444" ||
            meli_code === "5555555555" ||
            meli_code === "6666666666" ||
            meli_code === "7777777777" ||
            meli_code === "8888888888" ||
            meli_code === "9999999999"
          ) {
            newErrors.nationalCode = "فرمت کد ملی صحیح نمی باشد";
          }
          let c = parseInt(meli_code.charAt(9));
          let n =
            parseInt(meli_code.charAt(0)) * 10 +
            parseInt(meli_code.charAt(1)) * 9 +
            parseInt(meli_code.charAt(2)) * 8 +
            parseInt(meli_code.charAt(3)) * 7 +
            parseInt(meli_code.charAt(4)) * 6 +
            parseInt(meli_code.charAt(5)) * 5 +
            parseInt(meli_code.charAt(6)) * 4 +
            parseInt(meli_code.charAt(7)) * 3 +
            parseInt(meli_code.charAt(8)) * 2;
          let r = n - parseInt(n / 11) * 11;

          if (
            !(
              (r == 0 && r == c) ||
              (r == 1 && c == 1) ||
              (r > 1 && c == 11 - r)
            )
          ) {
            newErrors.nationalCode = "فرمت کد ملی صحیح نمی باشد";
          }
        } else {
          newErrors.nationalCode = "کد ملی باید 10 رقم باشد";
        }
      } else {
        newErrors.nationalCode = "کد ملی الزامی";
      }

      if (!password || password === "") {
        newErrors.password = "رمز الزامی است";
      } else if (password.length < 8) {
        newErrors.password = "رمز باید حداقل 8 کاراکتر باشد";
      }

      if (repassword !== password) {
        newErrors.repassword = "رمز و تکرار رمز یکسان نمی باشد";
      }

      if (!province || province === "" || province === "0") {
        newErrors.province = "انتخاب استان الزامی است";
      }

      if (!city || city === "" || city === 0) {
        newErrors.city = "انتخاب شهر الزامی است";
      }

      if (areas.length > 0) {
        if (!area || area === "" || area === "0") {
          newErrors.area = "منطقه الزامی";
        }
      }

      if (!address || address == "") {
        newErrors.address = "آدرس الزامی است";
      }
      if (!postCode || postCode == "") {
        newErrors.postCode = "کد پستی الزامی است";
      } else if (postCode.length < 10) {
        newErrors.postCode = "کد پستی صحیح نمی باشد";
      }

      if (tel) {
        if (tel.length < 11 || tel[0] != 0) {
          newErrors.tel = "فرمت تلفن وارد شده صحیح نمی باشد";
        }
      }

      if (!birthDay) {
        newErrors.birthDay = "تاریخ تولد الزامی است";
      }

      return newErrors;
    }

    if (type === "حقوقی") {
      const {
        Cname,
        CshomareSabt,
        CshenaseMeklii,
        Cphone,
        Cpasswordword,
        Crepeatepassword,
        province,
        city,
        address,
        ctel,
        postCode,
        area,
        managerName,
        managerFamily,
        managerNationalCode,
        birthDay,
      } = form;
      if (!Cname || Cname == "") newErrors.Cname = "نام الزامی است";

      if (!CshomareSabt || CshomareSabt === "")
        newErrors.CshomareSabt = "شماره ثبت الزامی است";

      if (!CshenaseMeklii || CshenaseMeklii == "") {
        newErrors.CshenaseMeklii = "شناسه ملی شرکت الزامی است";
      } else if (CshenaseMeklii.length !== 11) {
        newErrors.CshenaseMeklii = "شناسه ملی شرکت باید 11 رقم باشد";
      }

      if (!Cphone || Cphone == "") {
        newErrors.Cphone = "موبایل الزامی است";
      } else if (Cphone.length != 11) {
        newErrors.Cphone = "شماره موبایل 11 رقم باید باشد";
      } else if (Cphone[0] != 0 || Cphone[1] != 9) {
        newErrors.Cphone = "شماره موبایل معتبر نمی باشد";
      }

      if (!Cpasswordword || Cpasswordword == "")
        newErrors.Cpasswordword = "رمز الزامی است";
      else if (Cpasswordword.length < 8)
        newErrors.Cpasswordword = "رمز باید حداقل 8 کاراکتر باشد";

      if (Crepeatepassword !== Cpasswordword)
        newErrors.Crepeatepassword = "رمز و تکرار رمز یکسان نمی باشد";

      if (!province || province === "" || province === "0") {
        newErrors.province = "انتخاب استان الزامی است";
      }
      if (!city || city === "" || city === 0) {
        newErrors.city = "انتخاب شهر الزامی است";
      }

      if (areas.length > 0) {
        if (!area || area === "" || area === "0") {
          newErrors.area = "منطقه الزامی";
        }
      }

      if (!address || address == "") {
        newErrors.address = "آدرس الزامی است";
      }
      if (!postCode || postCode == "") {
        newErrors.postCode = "کد پستی الزامی است";
      } else if (postCode.length < 10) {
        newErrors.postCode = "کد پستی صحیح نمی باشد";
      }

      if (!ctel || ctel === "") {
        newErrors.ctel = "تلفن ثابت الزامی";
      } else if (ctel.length < 11 || ctel[0] != 0) {
        newErrors.ctel = "فرمت تلفن وارد شده صحیح نمی باشد";
      }

      if (!managerName || managerName === "") {
        newErrors.managerName = "نام مدیر عامل الزامی";
      }

      if (!managerFamily || managerFamily === "") {
        newErrors.managerFamily = "نام خانوادگی مدیر عامل الزامی";
      }

      if (!managerNationalCode || managerNationalCode === "") {
        newErrors.managerNationalCode = "کد ملی مدیر عامل الزامی";
      } else if (managerNationalCode.length !== 10) {
        newErrors.managerNationalCode = "کد ملی باید 10 رقمی باشد";
      } else if (validateFormatNationalCode(managerNationalCode) === false) {
        newErrors.managerNationalCode = "فرمت کد ملی رعایت نشده است";
      }

      if (!birthDay) {
        newErrors.birthDay = "تاریخ تولد الزامی است";
      }

      return newErrors;
    }
  };

  const setHaghighi = value => {
    setType(value);
    setForm(cur => ({ ...cur, type: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();

    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      sendData();
    }
  };

  const sendData = async () => {
    let data = {};
    setLoading(true);

    if (type === "حقوقی") {
      data = {
        name: form.Cname,
        phone: form.Cphone,
        nationalCode: form.CshenaseMeklii,
        email: form.Cemail,
        password: form.Cpasswordword,
        password_confirmation: form.Crepeatepassword,
        registrNumber: form.CshomareSabt,
        provinces: form.province,
        city: form.city,
        address: form.address,
        postCode: form.postCode,
        tel: form.ctel,
        description: form.address,
        type: 1,
        Default: 1,
        managerName: form.managerName,
        managerFamily: form.managerFamily,
        managerNationalCode: form.managerNationalCode,
      };
    } else {
      data = {
        password: form.password,
        password_confirmation: form.repassword,
        type: 0,
        name: form.name,
        family: form.family,
        phone: form.phone,
        nationalCode: form.nationalCode,
        city: form.city,
        address: form.address,
        postCode: form.postCode,
        provinces: form.province,
        email: form.email,
        area: form.area,
        tel: form.tel,
      };
    }

    data.birthDay = form.birthDay;

    const response = await postMethod("/user/v1/register", data);
    setLoading(false);

    if (response && response.status === 200) {
      setShowModalCode(true);
      return;
    }

    Swal.fire({
      icon: "error",
      text: response.message,
      showConfirmButton: true,
      confirmButtonText: response.data?.redirect
        ? "هدایت به صفحه ی ورود"
        : "متوجه شدم",
      showCancelButton: true,
      cancelButtonText: "لغو",
    }).then(res => {
      if (res.isConfirmed && response.data?.redirect) {
        window.location.href = response.data.redirect;
      }
    });
  };

  useEffect(() => {
    getProvince();
  }, []);

  return (
    <Container className="loginContainer">
      <Row className="justify-content-center">
        <Col xs={12} sm={8} lg={4} xl={5}>
          <img className="w-100" src="/auth/sing.png" />
        </Col>

        <Col xs={12} sm={12} lg={8} xl={7}>
          <p className="mb-2">
            <span>اگر قبلا ثبت نام کردید </span>
            <Link to="/login">از اینجا ورود کنید.</Link>
          </p>
          <div className="loginFormCol">
            <Card className="loginForm">
              <Tabs
                defaultActiveKey="home"
                style={{ paddingRight: 0 }}
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab
                  eventKey="home"
                  title="حقیقی"
                  onClick={() => setHaghighi("حقیقی")}
                >
                  <div title="حقیقی">
                    <Form
                      onSubmit={handleSubmit}
                      onKeyDown={e => {
                        if (
                          e.key === "Enter" &&
                          e.target.nodeName === "INPUT"
                        ) {
                          const form = e.target.form;
                          if (form?.elements === undefined) return;

                          const index = Array.prototype.indexOf.call(
                            form.elements,
                            e.target
                          );
                          if (form.elements[index + 1]) {
                            form.elements[index + 1].focus();
                          }
                          e.preventDefault();
                        }
                      }}
                    >
                      <Row>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              نام:<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.name}
                              type="text"
                              onChange={e => setField("name", e.target.value)}
                              isInvalid={!!errors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.name}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              نام خانوادگی:
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.family}
                              type="text"
                              onChange={e => setField("family", e.target.value)}
                              isInvalid={!!errors.family}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.family}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              شماره موبایل:
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.phone}
                              type="text"
                              onChange={e => {
                                setField("phone", e.target.value);
                                setPhone(e.target.value);
                              }}
                              isInvalid={!!errors.phone}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.phone}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              کد ملی:<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.nationalCode}
                              type="text"
                              onChange={e =>
                                setField("nationalCode", e.target.value)
                              }
                              isInvalid={!!errors.nationalCode}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.nationalCode}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <BirthDay
                          label="تاریخ تولد:"
                          errors={errors}
                          value={form.birthDay}
                          setField={setField}
                        />

                        <div className="d-flex flex-wrap">
                          <Col xs={12} md={6} className="ps-2">
                            <Form.Group>
                              <Form.Label>
                                رمز:<span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control
                                value={form.password}
                                type="password"
                                name="password"
                                autoComplete="new-password"
                                onChange={e =>
                                  setField("password", e.target.value)
                                }
                                isInvalid={!!errors.password}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.password}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col xs={12} md={6} className="pe-2">
                            <Form.Label>
                              تکرار رمز:
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.repassword}
                              type="password"
                              autoComplete="new-password"
                              onChange={e =>
                                setField("repassword", e.target.value)
                              }
                              isInvalid={!!errors.repassword}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.repassword}
                            </Form.Control.Feedback>
                          </Col>
                        </div>

                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              استان<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              type="text"
                              name="province"
                              onChange={e => getCities(e.target.value)}
                              isInvalid={!!errors.province}
                              value={form.province}
                            >
                              <option value={0}>...</option>
                              {provinces.map(item => (
                                <option value={item.id} key={item.id}>
                                  {item.faName}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.province}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              شهر<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              type="text"
                              name="city"
                              style={{ display: "none" }}
                              isInvalid={!!errors.city}
                            ></Form.Select>
                            <div className="dropdown-container">
                              <Select
                                name="cityMyAddress"
                                options={cityOption}
                                value={cityOption.find(
                                  c => c.value === form.city
                                )}
                                onChange={handleChangeCity}
                                isSearchable={true}
                                isInvalid={!!errors.city}
                              />
                            </div>
                            <Form.Control.Feedback type="invalid">
                              {errors.city}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              منطقه<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              type="text"
                              name="area"
                              onChange={e => setField("area", e.target.value)}
                              isInvalid={!!errors.area}
                              value={form.area}
                            >
                              <option value={0}>...</option>
                              {areas.map(item => (
                                <option value={item.id} key={item.id}>
                                  {item.faName}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.area}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              کد پستی<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.postCode}
                              type="text"
                              name="postCode"
                              onChange={e =>
                                setField("postCode", e.target.value)
                              }
                              isInvalid={!!errors.postCode}
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {errors.postCode}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Form.Group>
                        <Form.Label>
                          آدرس<span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          value={form.address}
                          as="textarea"
                          name="address"
                          className="form-control"
                          onChange={e => setField("address", e.target.value)}
                          isInvalid={!!errors.address}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.address}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Row>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>شماره تلفن ثابت:</Form.Label>
                            <Form.Control
                              value={form.tel}
                              name="tel"
                              className="form-control"
                              onChange={e => setField("tel", e.target.value)}
                              isInvalid={!!errors.tel}
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {errors.tel}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label> ایمیل: </Form.Label>
                            <Form.Control
                              value={form.email}
                              type="email"
                              name="email"
                              onChange={e => setField("email", e.target.value)}
                              isInvalid={!!errors.email}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.email}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <div className="loginButtonDiv">
                        {loading === true && (
                          <Button className="loginButton">
                            <div className="d-flex align-items-center">
                              <Spinner
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  fontSize: "0.8rem",
                                }}
                              />
                              <span className="me-1"> در حال ذخیره</span>
                            </div>
                          </Button>
                        )}
                        {loading === false && (
                          <Button
                            type="submit"
                            className="loginButton"
                            disabled={infoLoading === true}
                          >
                            تائید
                          </Button>
                        )}
                      </div>
                    </Form>
                  </div>
                </Tab>
                <Tab
                  eventKey="profile"
                  title="حقوقی"
                  onClick={() => setHaghighi("حقوقی")}
                >
                  <div title="حقوقی">
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              نام شرکت:
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.Cname}
                              type="text"
                              onChange={e => setField("Cname", e.target.value)}
                              isInvalid={!!errors.Cname}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.Cname}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              شماره ثبت شرکت:
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.CshomareSabt}
                              type="text"
                              onChange={e =>
                                setField("CshomareSabt", e.target.value)
                              }
                              isInvalid={!!errors.CshomareSabt}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.CshomareSabt}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              شناسه ملی شرکت:
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.CshenaseMeklii}
                              type="text"
                              onChange={e =>
                                setField("CshenaseMeklii", e.target.value)
                              }
                              isInvalid={!!errors.CshenaseMeklii}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.CshenaseMeklii}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              نام مدیر عامل:
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.managerName}
                              type="text"
                              onChange={e => {
                                setField("managerName", e.target.value);
                              }}
                              isInvalid={!!errors.managerName}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.managerName}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              نام خانوادگی مدیر عامل:
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.managerFamily}
                              type="text"
                              onChange={e => {
                                setField("managerFamily", e.target.value);
                              }}
                              isInvalid={!!errors.managerFamily}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.managerFamily}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              کد ملی مدیر عامل:
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.managerNationalCode}
                              type="text"
                              onChange={e => {
                                setField("managerNationalCode", e.target.value);
                              }}
                              isInvalid={!!errors.managerNationalCode}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.managerNationalCode}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              شماره موبایل:
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.Cphone}
                              type="text"
                              onChange={e => {
                                setField("Cphone", e.target.value);
                                setPhone(e.target.value);
                              }}
                              isInvalid={!!errors.Cphone}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.Cphone}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <BirthDay
                          label="تاریخ تولد مدیر عامل:"
                          errors={errors}
                          value={form.birthDay}
                          setField={setField}
                        />

                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              رمز:<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.Cpasswordword}
                              type="password"
                              autoComplete="new-password"
                              onChange={e =>
                                setField("Cpasswordword", e.target.value)
                              }
                              isInvalid={!!errors.Cpasswordword}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.Cpasswordword}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              تکرار رمز:
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.Crepeatepassword}
                              type="password"
                              autoComplete="new-password"
                              onChange={e =>
                                setField("Crepeatepassword", e.target.value)
                              }
                              isInvalid={!!errors.Crepeatepassword}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.Crepeatepassword}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              استان<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              type="text"
                              name="province"
                              onChange={e => getCities(e.target.value)}
                              isInvalid={!!errors.province}
                              value={form.province}
                            >
                              <option value={0}>...</option>
                              {provinces.map(item => (
                                <option value={item.id} key={item.id}>
                                  {item.faName}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.province}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              شهر<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              type="text"
                              name="city"
                              style={{ display: "none" }}
                              isInvalid={!!errors.city}
                            ></Form.Select>
                            <div className="dropdown-container">
                              <Select
                                name="cityMyAddress"
                                options={cityOption}
                                value={cityOption.find(
                                  c => c.value === form.city
                                )}
                                onChange={handleChangeCity}
                                isSearchable={true}
                                isInvalid={!!errors.city}
                              />
                            </div>
                            <Form.Control.Feedback type="invalid">
                              {errors.city}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              منطقه<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              type="text"
                              name="area"
                              onChange={e => setField("area", e.target.value)}
                              isInvalid={!!errors.area}
                              value={form.area}
                            >
                              <option value={0}>...</option>
                              {areas.map(item => (
                                <option value={item.id} key={item.id}>
                                  {item.faName}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.area}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              کد پستی<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.postCode}
                              type="text"
                              name="postCode"
                              onChange={e =>
                                setField("postCode", e.target.value)
                              }
                              isInvalid={!!errors.postCode}
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {errors.postCode}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Form.Group>
                        <Form.Label>
                          آدرس<span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          value={form.address}
                          as="textarea"
                          name="address"
                          className="form-control"
                          onChange={e => setField("address", e.target.value)}
                          isInvalid={!!errors.address}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.address}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Row>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label>
                              <span>شماره تلفن ثابت:</span>
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              value={form.ctel}
                              name="ctel"
                              className="form-control"
                              onChange={e => setField("ctel", e.target.value)}
                              isInvalid={!!errors.ctel}
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {errors.ctel}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label> ایمیل: </Form.Label>
                            <Form.Control
                              value={form.Cemail}
                              type="email"
                              onChange={e => setField("Cemail", e.target.value)}
                              isInvalid={!!errors.Cemail}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <div className="loginButtonDiv">
                        {loading === true && (
                          <Button className="loginButton">
                            <div className="d-flex align-items-center">
                              <Spinner
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  fontSize: "0.8rem",
                                }}
                              />
                              <span className="me-1"> در حال ذخیره</span>
                            </div>
                          </Button>
                        )}

                        {loading === false && (
                          <Button
                            type="submit"
                            className="loginButton"
                            disabled={infoLoading === true}
                          >
                            تائید
                          </Button>
                        )}
                      </div>
                    </Form>
                  </div>
                </Tab>
              </Tabs>
            </Card>
          </div>
        </Col>
      </Row>

      {showModalCode && (
        <RegisterUserSendAuthCode
          phone={phone}
          nationalCode={
            type === "حقیقی" ? form.nationalCode : form.CshenaseMeklii
          }
        />
      )}
    </Container>
  );
}

export default NormalUserRegister;
